/** QL-375 — the mandate verdict badges. Read with `useT(T)`. */
export const T = {
  en_GB: {
    // Badges
    statusOk: "Within range",
    statusDeviation: "Breach",
    statusAccepted: "Deviation accepted",
    statusNotAccepted: "Blocked by advisor",
    statusNotEvaluable: "Not checked",
    statusInformational: "Informational",
  },
  nb_NO: {
    statusOk: "Innenfor",
    statusDeviation: "Brudd",
    statusAccepted: "Avvik akseptert",
    statusNotAccepted: "Blokkert av rådgiver",
    statusNotEvaluable: "Ikke kontrollert",
    statusInformational: "Informativt",
  },
} as const;
